import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var ShieldCheck = createReactComponent("ShieldCheck", ["svg", defaultAttributes, [["path", {
  d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z",
  key: "epd26t"
}], ["path", {
  d: "M9 12l2 2 4-4",
  key: "1v3nuv"
}]]]);
export default ShieldCheck;